import React, { useEffect } from "react";
import { X } from "lucide-react";

/** Lightbox de foto pra vitrine /cruzeiros — fecha no X, clique fora, ou Esc. */
export default function CruzeiroLightbox({ src, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return (
    <div
      className="cruz-lightbox"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      role="dialog"
      aria-modal="true"
      data-testid="cruz-lightbox"
    >
      <button
        type="button"
        className="cruz-lightbox-close"
        onClick={onClose}
        aria-label="Fechar"
        data-testid="cruz-lightbox-close"
      >
        <X size={22} />
      </button>
      <img src={src} alt="" />
    </div>
  );
}
